<mat-dialog-content>
  <p class="info-message" [ngSwitch]="true">
    <ng-container *ngSwitchCase="generationEnabled">
      <div class="generate-stories-info">
        <ng-content select="[infoText1]"></ng-content>
        <ng-content select="[infoText2]"></ng-content>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="needExternalGptConfig">
      {{ 'GPT_STORIES.EXTERNAL_GPT_HAS_REQUIRED_CONFIG' | translate }}
    </ng-container>
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <q9-secondary-button mat-dialog-close>
    {{ 'POPUPS.CANCEL' | translate }}
  </q9-secondary-button>

  <q9-secondary-button (click)="readArticle()">
    {{ 'GPT_STORIES.READ_ARTICLE' | translate }}
  </q9-secondary-button>

  <q9-primary-button
    [disabled]="needExternalGptConfig || disableAction"
    (click)="changeStep.emit(1)">
    {{ 'GPT_STORIES.GENERATE_PROCEED' | translate }}
  </q9-primary-button>
</mat-dialog-actions>
